module.exports = __webpack_public_path__ + "static/media/icon_extension_pdf.986035ce.svg";